"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedarrows = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 57 54",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedarrows` : '') + (description ? ` desc-brandedarrows` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedarrows"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedarrows"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.85 13.39a18.65 18.65 0 0 1 26.38-.12l-4.82 4.83a2.83 2.83 0 0 0 2 4.83h14.98a2.8 2.8 0 0 0 2.8-2.82V5.05a2.82 2.82 0 0 0-4.8-2l-4.87 4.9a26.12 26.12 0 0 0-36.97.11 26.15 26.15 0 0 0-6.18 9.87 3.74 3.74 0 1 0 7.06 2.51c.9-2.56 2.36-4.98 4.42-7.04v-.01Z",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M0 33.3v15.06a2.82 2.82 0 0 0 4.8 2l4.87-4.9a26.12 26.12 0 0 0 36.98-.12 26.32 26.32 0 0 0 6.2-9.85 3.75 3.75 0 1 0-7.06-2.51 18.61 18.61 0 0 1-4.43 7.04 18.65 18.65 0 0 1-26.38.12l4.81-4.85a2.83 2.83 0 0 0-2-4.83H2.82A2.8 2.8 0 0 0 0 33.28v.02Z",
    fill: "#F26B1C"
  }));
};
var _default = exports.default = brandedarrows;